import { Alert, Button, Container, Grid, Rating, TextField, Typography } from "@mui/material";
import DocumentReviewItem from "../../components/DocumentReviewItem";
import { useEffect, useState } from "react";
import { Backend } from "../../services/Backend";
import { Link, useNavigate, useParams } from "react-router-dom";
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { isUserLoggedIn, userHasPermissions } from "../../utils/utils";
import { UserPermissions } from "../../dto/Permissions";
import Loader from "../../components/Loader";
import moment from "moment";

export default function DocumentPreviewPage() {
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();
    const { id } = useParams();
    const [doc, setDoc] = useState({});
    const [reviews, setReviews] = useState([]);

    const [error, setError] = useState();
    const [review, setReview] = useState("");
    const [rating, setRating] = useState(0);

    useEffect(() => {
        Backend.get(`document/${id}`)
            .then(res => setDoc(res));

        if (isUserLoggedIn()) {
            Backend.put(`document/${id}/views`);
        }
            
        Backend.get(`document/${id}/review`)
            .then(res => {
                setReviews(res);
                setIsLoading(false);
            });
    }, []);

    const sendReview = () => {
        setError("");
         
        if (rating === 0) {
            setError("Rating is required");
            return;
        } 

        if (review === "") {
            setError("Review is required");
            return;
        }

        Backend.post(`document/${id}/review`, { text: review, rating: rating })
            .then(res => {
                setReview("");
                setRating(0);
                Backend.get(`document/${id}/review`)
                .then(res => {
                    setReviews(res);
                });
            });
    }

    const downloadAttachment = async () => {
        if (await userHasPermissions(UserPermissions.DownloadDocument)) {
            Backend.download(`attachment/${doc.attachment?.guid}`)
            .then(file => {
                let tUrl = URL.createObjectURL(file);
                const tmp1 =  document.createElement("a");
                tmp1.href = tUrl;
                tmp1.download = doc.attachment?.fileName;
                document.body.appendChild(tmp1);
                tmp1.click();
                URL.revokeObjectURL(tUrl);
                tmp1.remove();
            });
        }
    }

    const backHandler = (e) => {
        e.preventDefault();

        navigate(-1);
    }

    return <Container maxWidth="lg" className="my-5">
        <Link to="#" onClick={backHandler}>Back</Link>
        <br />
        <br />
        {isLoading ? <div className="mx-auto w-fit"><Loader /></div>
        : <>
        <b className="text-4xl">{doc.title} </b>
        <Rating value={reviews.reduce((partialSum, r) => partialSum + r.rating, 0) / reviews.length} readOnly  />
        <br />
        <i>{moment(doc.uploadDate).local().format("YYYY-MM-DD")}</i>
        <br />
        <br />
        <Grid container spacing={2}>
            <Grid item xs={6}>
                <b>Publisher: </b> <span>{doc.publisher}</span>
            </Grid>
            <Grid item xs={6}>
                <b>Language: </b> <span>{doc.language}</span>
            </Grid>
            <Grid item xs={6}>
                <b>Disciplinary context: </b> <span>{doc.disciplinaryContext}</span>
            </Grid>
            <Grid item xs={6}>
                <b>Publication year: </b> <span>{doc.publicationYear}</span>
            </Grid>
            <Grid item xs={6}>
                <b>Pages: </b> <span>{doc.pages}</span>
            </Grid>
            <Grid item xs={6}>
                <b>Format: </b> <span>{doc.format}</span>
            </Grid>
            <Grid item xs={12}>
                <b>Upload by company: </b> <span>{doc.uploadByCompany ? "yes" : "no" }</span>
            </Grid>
            <Grid item xs={12}>
                <b>Short description: </b> <span>{doc.shortDescription }</span>
            </Grid>
        </Grid>
        <br />

        <div className="border border-gray-300 p-3 flex gap-3 w-fit rounded-xl cursor-pointer" onClick={downloadAttachment}>
            <AttachFileIcon />
            <p>{doc.attachment?.fileName}</p>
        </div>
        <br />
        <hr />
        <br />


        { isUserLoggedIn() && <>
            <div className="flex items-center gap-2 mb-1">
                <TextField size="small"  fullWidth label="Wirte review" value={review} onChange={(e) => setReview(e.target.value)}/>
                <Button variant="contained" onClick={sendReview}>Send</Button>
            </div>
            <Rating value={rating} onChange={(e, newValue) => setRating(newValue)}/>
            <br />
            {error && <Alert severity="error">{error}</Alert> }
            <br />
            <br />
        </> }
        <h3 className="text-2xl">Reviews</h3>
        { reviews.length === 0 ? "No reviews" : ""}
        {reviews.map(item => <DocumentReviewItem data={item}/>)}
        </> }

    </Container>
}